<div class="annotation-main-content" id="annotation-main-content">
  <div class="annotation-container" id="annotation-container">
    <div class="annotation-image-container" [ngClass]="{ isVerticalImage: isVerticalImage() }">
      <div class="canvas-button-container">
        <div class="canvas-area" id="canvas-area">
          <div class="main-canvas-area" id="main-canvas-area">
            <canvas #Canvas class="main-canvas" id="canvas"></canvas>
          </div>
        </div>

        <div class="dummy-canvas-area">
          <canvas #Canvas class="dummy-canvas" id="dummyCanvas"></canvas>
        </div>
        <div class="crop-canvas-area">
          <canvas #Canvas class="crop-canvas" id="cropCanvas"></canvas>
        </div>

        <ng-container *ngIf="isEditable">
          <!-- left icons start -->
          <div class="objects-area" id="objects-area" [ngStyle]="getObjectsAreaStyle()">
            <!-- Select Mode Button -->
            <div class="obj-btn select-mode">
              <button
                type="button"
                class="mini-buttons buttons"
                [ngStyle]="{ 'background-color': 'transparent' }"
                color="primary"
                mat-icon-button
                [matTooltip]="'imageAnnotationEdit.selectTooltip' | translate"
                matTooltipPosition="right"
                (click)="toggleFreeHand(false)"
              >
                <mat-icon id="select-icon" [style.color]="!canvas?.isDrawingMode ? 'var(--on-surface)' : 'var(--blues-8)'">highlight_alt</mat-icon>
              </button>
            </div>

            <!-- Add Rectangle Button -->
            <div class="obj-btn add-rect">
              <button
                type="button"
                class="mini-buttons buttons icon-custom-color"
                color="primary"
                mat-icon-button
                [matTooltip]="'imageAnnotationEdit.addRectangleTooltip' | translate"
                matTooltipPosition="right"
                (click)="addRect()"
              >
                <evc-svg-icon id="square-icon" class="edit-icon icon-custom-color" size="md" [icon]="squareIcon"></evc-svg-icon>
              </button>
            </div>
            <div class="divider"></div>

            <!-- Add Circle Button -->
            <div class="obj-btn add-circle">
              <button
                type="button"
                class="mini-buttons buttons icon-custom-color"
                [matTooltip]="'imageAnnotationEdit.addCircleTooltip' | translate"
                matTooltipPosition="right"
                (click)="addCircle()"
              >
                <svg id="circle-icon" class="icon-color" viewBox="0 0 48 48" width="23" height="23">
                  <defs>
                    <style>
                      .cls-1 {
                        fill: none;
                      }
                      .cls-2 {
                        fill: none;
                        stroke: var(--icon-color, #005cb9);
                        stroke-width: 2px;
                      }
                    </style>
                  </defs>
                  <g id="svg_icon_background">
                    <!-- Outlined Circle -->
                    <path
                      class="cls-2"
                      d="M24,6.5c9.66,0,17.5,7.84,17.5,17.5S33.66,41.5,24,41.5,6.5,33.66,6.5,24,14.34,6.5,24,6.5m0-2.5C12.95,4,4,12.95,4,24s8.95,20,20,20,20-8.95,20-20S35.05,4,24,4Z"
                    />
                  </g>
                </svg>
              </button>
            </div>
            <div class="divider"></div>

            <!-- Add Line Button -->
            <div class="obj-btn add-line">
              <button
                type="button"
                class="mini-buttons buttons icon-custom-color"
                [matTooltip]="'imageAnnotationEdit.addLineTooltip' | translate"
                matTooltipPosition="right"
                (click)="addLine()"
              >
                <svg class="image-edit-svg icon-color" viewBox="0 0 48 48">
                  <defs>
                    <style>
                      .cls-1 {
                        fill: none;
                      }
                      .cls-2 {
                        fill: var(--icon-color, #005cb9);
                      }
                    </style>
                  </defs>
                  <g id="svg_icon_background">
                    <!-- Filled Horizontal Line -->
                    <rect class="cls-2" x="4" y="22" width="40" height="4" />
                  </g>
                </svg>
              </button>
            </div>
            <div class="divider"></div>

            <!-- Add Arrow Button -->
            <div class="obj-btn add-arrow">
              <button
                type="button"
                class="mini-buttons buttons icon-custom-color"
                [matTooltip]="'imageAnnotationEdit.addArrowTooltip' | translate"
                matTooltipPosition="right"
                (click)="addAllow()"
              >
                <svg class="image-edit-svg" viewBox="0 0 48 48">
                  <defs>
                    <style>
                      .cls-1 {
                        fill: none;
                      }
                      .cls-2 {
                        fill: var(--icon-color, #005cb9);
                      }
                    </style>
                  </defs>
                  <g id="svg_icon_background">
                    <!-- Filled Arrow -->
                    <path
                      class="cls-2"
                      d="m13.69,11.87l6.03,6.02,1.77,1.77-1.77,1.77-12.18,12.18,6.86,6.86,12.18-12.18,1.77-1.77,1.77,1.77,6.02,6.02,4.79-27.23-27.23,4.79Zm24.07,27.61l-9.42-9.42-13.95,13.95-10.39-10.39,13.95-13.95-9.42-9.42,35.48-6.24-6.24,35.48Z"
                    />
                  </g>
                </svg>
              </button>
            </div>
            <div class="divider"></div>

            <!-- Add Text Button -->
            <div class="obj-btn add-text">
              <button
                type="button"
                class="mini-buttons buttons icon-custom-color"
                [matTooltip]="'imageAnnotationEdit.addTextTooltip' | translate"
                matTooltipPosition="right"
                (click)="addText()"
              >
                <svg id="svg_icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22">
                  <defs>
                    <style>
                      .cls-1 {
                        fill: none;
                      }
                      .cls-1,
                      .cls-2 {
                        stroke-width: 0;
                      }
                      .cls-2 {
                        fill: var(--icon-color, #005cb9);
                      }
                    </style>
                  </defs>
                  <g id="svg_icon_background">
                    <rect class="cls-1" width="24" height="24" />
                  </g>
                  <g id="svg_icon_element_01">
                    <rect class="cls-2" x="11.26" y="5.18" width="1.49" height="1.49" />
                    <rect class="cls-2" x="7.54" y="11.38" width="8.93" height="1.49" />
                    <rect class="cls-2" x="11.26" y="8.28" width="1.49" height="1.49" />
                    <path
                      class="cls-2"
                      d="m13.98,14.48H3.57V3.57h16.87v8.56h1.49V3.57c0-.4-.15-.74-.45-1.04-.3-.3-.64-.45-1.04-.45H3.57c-.4,0-.74.15-1.04.45s-.45.64-.45,1.04v10.91c0,.38.15.72.45,1.03s.64.46,1.04.46h10.42v-1.49Z"
                    />
                    <rect class="cls-2" x="8.21" y="8.28" width="1.49" height="1.49" />
                    <rect class="cls-2" x="8.21" y="5.18" width="1.49" height="1.49" />
                    <rect class="cls-2" x="14.33" y="8.28" width="1.49" height="1.49" />
                    <rect class="cls-2" x="5.13" y="5.18" width="1.49" height="1.49" />
                    <rect class="cls-2" x="5.13" y="8.28" width="1.49" height="1.49" />
                    <rect class="cls-2" x="17.38" y="8.28" width="1.49" height="1.49" />
                    <rect class="cls-2" x="14.33" y="5.18" width="1.49" height="1.49" />
                    <rect class="cls-2" x="17.38" y="5.18" width="1.49" height="1.49" />
                    <path
                      class="cls-2"
                      d="m16.89,13h1.67l3.46,8.99h-1.69l-.84-2.38h-3.59l-.84,2.38h-1.62l3.45-8.99Zm-.55,5.41h2.74l-1.35-3.86h-.04l-1.36,3.86Z"
                    />
                  </g>
                </svg>
              </button>
            </div>
            <div class="divider"></div>

            <!-- Freehand Button -->
            <div class="obj-btn freehand">
              <button
                type="button"
                class="mini-buttons buttons icon-custom-color"
                [matTooltip]="'imageAnnotationEdit.freeHandTooltip' | translate"
                matTooltipPosition="right"
                (click)="toggleFreeHand(true)"
                [ngStyle]="getSelectedIconStyle(canvas?.isDrawingMode)"
              >
                <svg id="draw-icon" class="icon-color" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22">
                  <defs>
                    <style>
                      .cls-1 {
                        fill: none;
                      }
                      .cls-2 {
                        fill: var(--icon-color, #005cb9);
                      }
                    </style>
                  </defs>
                  <g id="svg_icon_background">
                    <rect class="cls-1" width="24" height="24" />
                  </g>
                  <g id="svg_icon_element_01">
                    <path
                      class="cls-2"
                      d="m5.58,21.61c.23.11.43.23.64.29.53.15,1.08-.14,1.32-.67.21-.46.06-1.05-.37-1.36-.39-.29-.83-.54-1.18-.88-1.16-1.11-1.4-2.49-1.09-4.01.17-.8.48-1.55.87-2.26.61-1.11,1.11-2.26,1.32-3.52.38-2.38-.18-4.45-2.02-6.08-.38-.34-.82-.63-1.26-.89-.54-.33-1.22-.15-1.53.35-.35.57-.22,1.2.33,1.6.42.31.88.59,1.24.96,1.06,1.1,1.26,2.44.96,3.88-.16.79-.47,1.53-.86,2.24-.62,1.13-1.14,2.3-1.36,3.59-.39,2.36.2,4.4,2.02,6.02.31.28.66.51.97.74Z"
                    />
                    <polygon
                      class="cls-2"
                      points="15.45 11.57 16.48 12.59 10.49 18.58 10.49 20.44 12.35 20.44 18.34 14.45 19.36 15.48 12.93 21.91 9.02 21.91 9.02 18 15.45 11.57"
                    />
                    <path
                      class="cls-2"
                      d="m19.36,15.48l-3.91-3.91,2.23-2.23c.22-.22.47-.33.77-.33s.55.11.77.33l2.37,2.37c.22.22.33.47.33.77s-.11.55-.33.77l-2.23,2.23Z"
                    />
                  </g>
                </svg>
              </button>
            </div>
            <div class="divider"></div>

            <!-- Remove Object Button -->
            <div class="obj-btn remove">
              <button
                type="button"
                class="mini-buttons buttons icon-custom-color"
                [disabled]="!isActiveObject()"
                [matTooltip]="'imageAnnotationEdit.removeTooltip' | translate"
                matTooltipPosition="right"
                (click)="removeObject()"
              >
                <svg id="svg_icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22">
                  <defs>
                    <style>
                      .cls-1 {
                        fill: none;
                      }
                      .cls-2 {
                        fill: var(--icon-color, #005cb9);
                      }
                    </style>
                  </defs>
                  <g id="svg_icon_background">
                    <rect class="cls-1" width="24" height="24" />
                  </g>
                  <g id="svg_icon_element_01">
                    <path
                      class="cls-2"
                      d="m2.06,15.22c.16-.2.31-.42.5-.6.99-1,1.99-2,2.99-2.99.05-.05.11-.09.15-.12-.08-.18-.18-.33-.21-.49-.06-.29.05-.53.26-.73.87-.86,1.73-1.73,2.59-2.59,1.56-1.56,3.13-3.13,4.69-4.69.47-.47.87-.47,1.35,0,2.4,2.4,4.81,4.81,7.21,7.21.46.46.46.87,0,1.32-2.41,2.41-4.83,4.83-7.24,7.24-.41.41-.75.44-1.27.07-.03.05-.06.12-.11.17-.67.67-1.35,1.34-2.01,2.02-.2.21-.43.31-.73.3-.73,0-1.46,0-2.19,0-.27,0-.49-.09-.68-.28-1.68-1.68-3.36-3.36-5.03-5.04-.11-.11-.19-.25-.28-.38,0-.14,0-.28,0-.43Zm11.65-10.63c-2.1,2.1-4.21,4.21-6.3,6.3,2.09,2.09,4.2,4.2,6.28,6.28,2.1-2.1,4.21-4.2,6.3-6.3-2.09-2.09-4.2-4.19-6.28-6.28Zm-9.74,10.86s.02.03.04.04c1.4,1.4,2.8,2.8,4.2,4.19.06.06.16.09.24.09.47,0,.93.01,1.4,0,.1,0,.22-.05.28-.12.52-.51,1.03-1.02,1.54-1.53.12-.12.25-.22.35-.31-1.77-1.77-3.5-3.5-5.21-5.21-.93.93-1.88,1.88-2.84,2.84Z"
                    />
                  </g>
                </svg>
              </button>
            </div>
          </div>
          <!-- left icons end -->
        </ng-container>
      </div>
    </div>
  </div>
  <div class="function-area" id="function-area" *ngIf="isEditable" [ngStyle]="getFuncAreaStyle()">
    <!-- Undo Redo Arrows Start -->
    <div class="property canvas buttons undo-redo" *ngIf="isEditable">
      <div [matTooltip]="'imageAnnotationEdit.undoTooltip' | translate" class="undo">
        <button type="button" class="mini-buttons history-buttons" [disabled]="isUndoDisabled" color="primary" mat-stroked-button (click)="undo()">
          <mat-icon [style.color]="isUndoDisabled ? 'var(--on-surface)' : 'var(--blues-8)'" class="icon">undo</mat-icon>
        </button>
      </div>

      <div [matTooltip]="'imageAnnotationEdit.redoTooltip' | translate" class="redo">
        <button type="button" class="mini-buttons history-buttons" [disabled]="isRedoDisabled" color="primary" mat-stroked-button (click)="redo()">
          <mat-icon [style.color]="isRedoDisabled ? 'var(--on-surface)' : 'var(--blues-8)'" class="icon">redo</mat-icon>
        </button>
      </div>
    </div>
    <!-- Undo Redo Arrows End -->

    <!-- Annotation/Image Menu Start -->
    <div class="function-label">
      <nav mat-tab-nav-bar>
        <div mat-tab-link class="function-tab" [active]="isAnnotationFunc" (click)="changeMode(editFunctions[0])">
          <a class="function-category-title" [ngClass]="{ 'is-active': isAnnotationFunc }">
            {{ this.editFunctions[0] }}
          </a>
        </div>
        <div mat-tab-link class="function-tab" [active]="!isAnnotationFunc" (click)="changeMode(editFunctions[1])">
          <a class="function-category-title" [ngClass]="{ 'is-active': !isAnnotationFunc }">
            {{ this.editFunctions[1] }}
          </a>
        </div>
      </nav>
    </div>
    <!-- Annotation/Image Menu End -->

    <!-- Annotation Items Start -->
    <ng-container *ngIf="isAnnotationFunc">
      <div>
        <div class="properties-area">
          <div class="form-group">
            <div class="label-border">
              <label class="form-group-label">
                {{ "imageAnnotationEdit.objectStyleFormLabel" | translate }}
              </label>
            </div>

            <div class="property fill">
              <label class="property-label">{{ "imageAnnotationEdit.fillColor" | translate }}</label>
              <mat-checkbox class="check-box" [(ngModel)]="isFilled" [disabled]="!isEditable" (change)="changeFillColor()">
                {{ "imageAnnotationEdit.fill" | translate }}
              </mat-checkbox>
              <mat-form-field class="color-select-box">
                <mat-select [(value)]="fillColor" (selectionChange)="changeFillColor()">
                  <mat-select-trigger>
                    <mat-icon class="mark-icon icon-color" [style.color]="fillColor">lens</mat-icon>
                    {{ getColorName(fillColor) }}
                  </mat-select-trigger>
                  <mat-option *ngFor="let item of selectColors" [value]="item.color" (click)="$event.stopPropagation()">
                    <mat-icon class="mark-icon" [style.color]="item.color">lens</mat-icon>
                    ({{ "imageAnnotationEdit.annotation_color_" + item.name.toLowerCase() | translate }})
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <label class="property-label">{{ "imageAnnotationEdit.borderColor" | translate }}</label>
            <div class="property border">
              <!-- Border Property Content -->
              <mat-form-field class="color-select-box">
                <mat-select #border [(value)]="borderType" (selectionChange)="changeBorderType()">
                  <mat-option *ngFor="let border of borderTypeList" [value]="border" (click)="$event.stopPropagation()"> {{ border }}px </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="color-select-box">
                <mat-select [(value)]="borderColor" (selectionChange)="changeBorderColor()">
                  <mat-select-trigger>
                    <mat-icon class="mark-icon" [style.color]="borderColor">lens</mat-icon>
                    {{ getColorName(borderColor) }}
                  </mat-select-trigger>
                  <mat-option *ngFor="let item of selectColors" [value]="item.color" (click)="$event.stopPropagation()">
                    <mat-icon class="mark-icon" [style.color]="item.color">lens</mat-icon>
                    ({{ "imageAnnotationEdit.annotation_color_" + item.name.toLowerCase() | translate }})
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="form-group">
            <div class="label-border">
              <label class="form-group-label">
                {{ "imageAnnotationEdit.objectOrderButtonLabel" | translate }}
              </label>
            </div>
            <div class="property layer-move buttons">
              <!-- Layer Move Buttons -->
              <button
                type="button"
                class="mini-buttons layer-buttons"
                color="primary"
                mat-stroked-button
                [matTooltip]="'imageAnnotationEdit.bringForwardTooltip' | translate"
                (click)="changeLayer(true)"
              >
                <mat-icon class="icon icon-color">flip_to_front</mat-icon>
              </button>

              <button
                type="button"
                class="mini-buttons layer-buttons"
                color="primary"
                mat-stroked-button
                [matTooltip]="'imageAnnotationEdit.bringFrontTooltip' | translate"
                (click)="changeLayerToTop()"
              >
                <mat-icon class="place-front icon-color">flip_to_front</mat-icon>
              </button>

              <button
                type="button"
                class="mini-buttons layer-buttons"
                color="primary"
                mat-stroked-button
                [matTooltip]="'imageAnnotationEdit.sendBackwardTooltip' | translate"
                (click)="changeLayer(false)"
              >
                <mat-icon class="icon icon-color">flip_to_back</mat-icon>
              </button>

              <button
                type="button"
                class="mini-buttons layer-buttons"
                color="primary"
                mat-stroked-button
                [matTooltip]="'imageAnnotationEdit.sendBackTooltip' | translate"
                (click)="changeLayerToBottom()"
              >
                <mat-icon class="place-background icon-color">flip_to_back</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- Annotation Items End -->

    <!-- Image Items Start -->
    <ng-container *ngIf="!isAnnotationFunc">
      <div class="properties-area image-retouch">
        <div class="form-group">
          <div class="label-border">
            <label class="form-group-label">
              {{ "imageAnnotationEdit.imageRotation" | translate }}
            </label>
          </div>
          <div class="property layer-move buttons">
            <!-- Image Rotation Buttons -->
            <button
              type="button"
              class="mini-buttons layer-buttons"
              color="primary"
              mat-stroked-button
              [matTooltip]="'imageAnnotationEdit.leftRotateTooltip' | translate"
              (click)="rotate(-90, null, true)"
            >
              <mat-icon class="icon icon-color">rotate_left</mat-icon>
            </button>

            <button
              type="button"
              class="mini-buttons layer-buttons"
              color="primary"
              mat-stroked-button
              [matTooltip]="'imageAnnotationEdit.rightRotateTooltip' | translate"
              (click)="rotate(90, null, true)"
            >
              <mat-icon class="icon icon-color">rotate_right</mat-icon>
            </button>
          </div>
        </div>

        <div class="form-group">
          <div class="label-border">
            <label class="form-group-label">
              {{ "imageAnnotationEdit.imageTrimming" | translate }}
            </label>
          </div>
          <div class="property remove buttons">
            <!-- Image Trimming Buttons -->
            <button
              type="button"
              class="mini-buttons remove-buttons"
              color="primary"
              mat-stroked-button
              [matTooltip]="'imageAnnotationEdit.trimTooltip' | translate"
              (click)="showTrimCanvas()"
            >
              <mat-icon class="icon icon-color">crop</mat-icon>
            </button>

            <button
              type="button"
              class="mini-buttons remove-buttons"
              color="primary"
              mat-stroked-button
              [matTooltip]="'imageAnnotationEdit.revertOriginalTooltip' | translate"
              (click)="revertToOriginal()"
            >
              <mat-icon class="icon icon-color">crop_original</mat-icon>
            </button>
          </div>
        </div>

        <div class="form-group">
          <div class="label-border">
            <label class="form-group-label">
              {{ "imageAnnotationEdit.imageBrightness" | translate }}
            </label>
          </div>
          <div class="property brightness buttons">
            <!-- Brightness Slider -->

            <mat-slider
              class="brightness-slider icon-color"
              [(ngModel)]="brightness"
              [max]="maxBrightness"
              [min]="minBrightness"
              [step]="0.05"
              thumbLabel
              [displayWith]="formatBrightnessLabel"
              #ngSlider
            >
              <input
                matSliderThumb
                (input)="changeBrightness({ source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value }.value, false)"
                #ngSliderThumb="matSliderThumb"
                (change)="changeBrightness({ source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value }.value, true)"
              />
            </mat-slider>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- Image Items End -->
  </div>
</div>
